import { Button } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { Input } from 'Components/Input'
import { useEffect, useState } from 'react'

import { useForm } from 'react-hook-form'
import { makePutRequest } from 'utils/api'
import { makePostRequest } from 'utils/api'
import { convertToMuiDate } from 'utils/helpers'
import urls from 'utils/urls'

export default function UpdateVehicle({
  vehicle,
  openModel,
  setOpenModel,
  setVehicule,
  field,
  fetchVehicleDetail,
}) {
  const [formField, setFormField] = useState('')
  const [formFieldType, setFormFieldType] = useState('')

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {},
  })
  useEffect(() => {
    if (field === 'Génération') {
      setFormField('Generation')
      setFormFieldType('number')
    }
    if (field === 'Puissance') {
      setFormField('Puissance')
      setFormFieldType('number')
    }
    if (field === 'Consommation') {
      setFormField('Conso')
      setFormFieldType('number')
    }
    if (field === 'Version') {
      setFormField('Version')
      setFormFieldType('text')
    }
  }, [])
  const handleClose = () => {
    // setOpen(false)
    setOpenModel(false)
    reset()
  }

  const onSubmit = async (data) => {
    const payload = {
      ...vehicle,
      ...data,
      DatePurch: convertToMuiDate(vehicle.DatePurch),
    }

    const response = await makePutRequest(
      urls.crudVehiclesOperations + payload.id + '/',
      payload,
      {},
      true,
    )
    if (response.status === 200) {
      fetchVehicleDetail()
      handleClose()
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={openModel} onClose={handleClose}>
        {/* <DialogTitle color="black">Ajout plante</DialogTitle> */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: formFieldType,
                step: '1',
              }}
              name={formField}
              label={field}
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
